


import React from "react";
import { useMediaQuery } from 'react-responsive';

const Erpfeatures = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#025261",
      color: "#fff",
      flexWrap: "wrap",
    },
    leftSide: {
      flex: 1,
      paddingRight: isMobile ? "0" : "2rem",
      paddingTop: isMobile ? "2rem" : "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: isMobile ? "0" : "1rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "bold",
      color: "white",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "1rem 0",
      textAlign: "justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.5rem",
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      marginRight: "0.5rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1.2rem" : "1.5rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      width: isMobile ? "100%" : "90%",
      maxWidth: "500px",
      height: "auto",
      borderRadius: "8px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/erpfeatures.png"
            alt="ERP Features"
            style={styles.image}
          />
        </div>
      </div>
      <div style={styles.leftSide}>
        <h2 style={styles.header}>The Power of ERP Solutions</h2>
        <p style={styles.paragraph}>
          ERP (Enterprise Resource Planning) systems are the backbone of modern businesses, enabling seamless integration across departments, improving efficiency, and enhancing decision-making. Our team specializes in designing and implementing custom ERP solutions tailored to meet your business needs, ensuring smooth operations and data-driven insights across your entire organization.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Centralized Data Management for Real-Time Insights and Reporting
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Streamlined Workflow Automation to Improve Efficiency and Reduce Errors
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Customizable Modules for Finance, HR, Inventory, Sales, and more
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Scalable Solutions that Grow with Your Business Needs
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Enhanced Collaboration Across Teams and Departments
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Erpfeatures;